import { createFileRoute } from '@tanstack/react-router'
import { useT } from '@/shared/i18n'
import { ConnectionIndicator } from '@/shared/realtime'

export const Route = createFileRoute('/tv/')({
  component: TvHome,
})

function TvHome() {
  const t = useT()
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-6 text-center">
      <h1 className="text-5xl font-bold">{t('tv.title')}</h1>
      <p className="text-muted-foreground">{t('tv.placeholder')}</p>
      <ConnectionIndicator />
    </div>
  )
}
